const MEDIUM = "medium";
const HIGH = "high";
const ALLTIME = "1 year";
const CLOSED = "Closed";
const ORIGIN = "original";
const CURRENT_VALUE = "currentValue";
const NEW_CASE = "New case";

export const CONSTANTS = {
  MEDIUM,
  HIGH,
  ALLTIME,
  CLOSED,
  ORIGIN,
  CURRENT_VALUE,
  NEW_CASE
};

export default CONSTANTS;
